const variants = (attributes) => {
  let attrs = [];

  for (const [attr, values] of Object.entries(attributes))
    attrs.push(values.map((v) => ({ [attr]: v })));

  attrs =
    attrs.filter((e) => e.length !== 0).length > 0
      ? attrs
          .filter((e) => e.length !== 0)
          .reduce((a, b) => a.flatMap((d) => b.map((e) => ({ ...d, ...e }))))
      : [];

  return attrs;
};

export default variants;
